const $ = window.jQuery;
const $window = window.$window || $(window);
require('isomorphic-fetch');
var slugify = require('slugify')
require('jquery-validation');

const careersApi = {
    init() {
        if (document.getElementById("open-positions")) {
            fetch('https://api.eu.lever.co/v0/postings/tuumplatform')
                .then(function (response) {
                    if (response.status >= 400) {
                        throw new Error("Bad response from server");
                    }
                    return response.json();
                })
                .then(function (positions) {
                    //console.log(positions);
                    const allLocations = [];
                    const allRoles = [];
                    //const allPositions = [];

                    positions.forEach(positions => {
                        var title = positions.text;
                        var slug = slugify(title, { lower: true }) // some-string
                        var team = positions.categories.team;
                        var location = positions.categories.location;
                        var hostedUrl = positions.hostedUrl;
                        // push roles / locations to array
                        allLocations.push(location);
                        allRoles.push(team);
                        // append available job adds
                        $('.job-listings').append(
                            '<tr data-href="' + hostedUrl + '" class="' + location + ' ' + team + ' job-listing-title group cursor-pointer hover:bg-white/30 focus-visible:rounded focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-4 focus-visible:outline-brand-blue/70" tabindex="0">' +
                            //'<tr data-href="/career/' + slug + '" class="' + location + ' ' + team + ' job-listing-title group cursor-pointer hover:bg-white/30 focus-visible:rounded focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-4 focus-visible:outline-brand-blue/70" tabindex="0">' +
                            '<td class="relative border-b border-solid border-brand-black p-0 text-left text-sm xxs:text-base xs:text-2xl">' +
                            '<div class="invisible absolute inset-y-0 -left-2 w-2 bg-gradient-to-l from-white/30 to-transparent group-hover:visible"></div>' +
                            '<p class="py-4 xs:py-5">' + title + '</p>' +
                            '</td>' +
                            '<td class="border-b border-solid border-brand-black p-0 text-center text-xs xs:text-base">' +
                            '<p class="py-4 px-2 xxs:px-4 xs:py-5">' + team + '</p>' +
                            '</td>' +
                            '<td class="relative border-b border-solid border-brand-black p-0 text-right text-xs xs:text-base">' +
                            '<p class="py-4 xs:py-5">' + location + '</p>' +
                            '<div class="invisible absolute inset-y-0 -right-2 w-2 bg-gradient-to-r from-white/30 to-transparent group-hover:visible"></div>' +
                            '</td>' +
                            '</tr>'
                        );
                    }); // end job adds loop
                    // open Lever link on click
                    $(".job-listing-title ").on("click", function () {
                        var href = $(this).data("href");
                        location.href = href;
                    });
                    // filter out available locations/roles from JSON array 
                    /* function onlyUnique(value, index, self) {
                        return self.indexOf(value) === index;
                    } */
                    /* var uniqueLocations = allLocations.filter(onlyUnique);
                    //console.log(uniqueLocations); // ['a', 1, 2, '1']
                    var uniqueRoles = allRoles.filter(onlyUnique);
                    //console.log(uniqueRoles); // ['a', 1, 2, '1']
                    // create location filters
                    uniqueLocations.forEach(uniqueLocations => {
                        var locationFilter = uniqueLocations;
                        //$('.location-filter').append(
                        //'<li class="no-gap:m-1"><button data-location="' + locationFilter + '" class="filter-btn filter-location-btn flex justify-center items-center gap-2 rounded-xl select-none min-w-fit tracking-normal px-3 py-1 xs:px-3.5 xs:py-2 bg-transparent hover:bg-brand-black/10 active:bg-brand-black ring-1 ring-inset ring-brand-black focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-0 focus-visible:outline-brand-black/20 text-brand-black active:text-white text-xs xs:text-sm rounded-xl" tabindex="0" type="button"><span class="no-gap:ml-2 no-gap:first:ml-0">' + locationFilter + '</span></button></li>'
                        //);
                    }); */
                    $(".filter-location-btn").click(function () {
                        $('.filter-role-btn').removeClass('active');
                        $('.filter-role-btn.all').addClass('active');
                        if ($(this).hasClass("all")) {
                            $(".job-listing-title")
                                .removeClass("active")
                                .show();
                            $('.filter-location-btn').removeClass('active');
                            $(this).addClass("active");
                        } else {
                            var locationActive = $(this).data("location");
                            $('.filter-location-btn').removeClass('active');
                            $(this).addClass("active");
                            $(".job-listing-title").hide();
                            $(".job-listing-title." + locationActive).show();
                        }
                    });
                    // create roles filters 
                    /* uniqueRoles.forEach(uniqueRoles => {
                        var rolesFilter = uniqueRoles;
                        //$('.roles-filter').append(
                        // '<li class="no-gap:m-1"><button data-role="' + rolesFilter + '" class="filter-btn filter-role-btn flex justify-center items-center gap-2 rounded-xl select-none min-w-fit tracking-normal px-3 py-1 xs:px-3.5 xs:py-2 bg-transparent hover:bg-brand-black/10 active:bg-brand-black ring-1 ring-inset ring-brand-black focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-0 focus-visible:outline-brand-black/20 text-brand-black active:text-white text-xs xs:text-sm rounded-xl" tabindex="0" type="button"><span class="no-gap:ml-2 no-gap:first:ml-0">' + rolesFilter + '</span></button></li>'
                        //);
                    }); */
                    $(".filter-role-btn").click(function () {
                        $('.filter-location-btn').removeClass('active');
                        $('.filter-location-btn.all').addClass('active');
                        if ($(this).hasClass("all")) {
                            $(".job-listing-title")
                                .removeClass("active")
                                .show();
                            $('.filter-role-btn').removeClass('active');
                            $(this).addClass("active");
                        } else {
                            var roleActive = $(this).data("role");
                            $('.filter-role-btn').removeClass('active');
                            $(this).addClass("active");
                            $(".job-listing-title").hide();
                            $(".job-listing-title." + roleActive).show();
                        }
                    });
                    // end filterings

                });
        } // #open-positions



        var $form = $("#tuum-career-apply");
        var $submitbutton = $(".career-submit");

        $form.on("blur", "input", () => {
            if ($form.valid()) {
                $submitbutton.removeAttr("disabled");
            } else {
                $submitbutton.attr("disabled", "disabled");
            }
        });
    },
};

export default careersApi;
